import { connect } from 'react-redux';

import PdpAddToCartModal from 'components/AddToCartModal';
import * as actions from 'state/actions';
import CartSelector from 'state/selectors/cart';
import { addToCartModalIsOpen } from 'state/selectors/pdp';

const mapStateToProps = (state, ownProps) => {
  const { product, currentVariant, recommendationsOption } = ownProps;
  const isOpen = addToCartModalIsOpen(state);
  const { itemCount, subtotalWithCurrency } = CartSelector.getCart(state);

  return {
    isOpen,
    itemCount,
    subtotalWithCurrency,
    product,
    currentVariant,
    recommendationsOption,
  };
};

const mapDispatchToProps = dispatch => ({
  closeModal: ({ closeType, closeLocation }) => {
    dispatch(actions.closeModal());
    dispatch(actions.trackPdpCloseAddToCartModal(closeType, closeLocation));
  },
  openCart: () => dispatch(actions.openCart()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PdpAddToCartModal);
